import { render } from "./BodyMobileHeader.vue?vue&type=template&id=fd03eb3c&scoped=true&lang=pug"
import script from "./BodyMobileHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyMobileHeader.vue?vue&type=script&setup=true&lang=js"

import "./BodyMobileHeader.vue?vue&type=style&index=0&id=fd03eb3c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd03eb3c"]])

export default __exports__